import { render, staticRenderFns } from "./actDetailList.vue?vue&type=template&id=927e049e&scoped=true&"
import script from "./actDetailList.vue?vue&type=script&lang=js&"
export * from "./actDetailList.vue?vue&type=script&lang=js&"
import style0 from "./actDetailList.vue?vue&type=style&index=0&id=927e049e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927e049e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('927e049e')) {
      api.createRecord('927e049e', component.options)
    } else {
      api.reload('927e049e', component.options)
    }
    module.hot.accept("./actDetailList.vue?vue&type=template&id=927e049e&scoped=true&", function () {
      api.rerender('927e049e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/activity/marketing_activity_close/components/actDetailList.vue"
export default component.exports